import { createSlice } from '@reduxjs/toolkit';

const initialState={
    eventcustomisations:null
}
export const eventcustomisationsSlice = createSlice({
  name: 'eventcustomisations',
  initialState,
  reducers: {

    
      
      setEventcustomisation: (state, action) => {
        state.eventcustomisations = action.payload;
        
      },
      setLogoutEventcustomisation: (state,action)=>{
      state.eventcustomisations=null
    }
  },
});

export const {  setEventcustomisation,setLogoutEventcustomisation} = eventcustomisationsSlice.actions;

export default eventcustomisationsSlice.reducer;
